import React from 'react';

const CloseIcon = ({ size, color = '#000' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 512.000000 512.000000'
    preserveAspectRatio='xMidYMid meet'
  >
    <g
      transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)'
      stroke={color}
    >
      <path
        d='M1055 4146 c-41 -18 -83 -69 -91 -111 -17 -91 -49 -54 689 -792 l682
   -683 -682 -682 c-740 -741 -706 -702 -688 -795 9 -49 69 -109 118 -118 93 -18
   54 -52 795 688 l682 682 683 -682 c740 -740 701 -706 794 -688 49 9 109 69
   118 118 18 93 52 54 -688 795 l-682 682 682 683 c740 740 706 701 688 794 -9
   49 -69 109 -118 118 -93 18 -54 52 -795 -688 l-682 -682 -678 677 c-377 378
   -689 682 -705 688 -38 14 -85 12 -122 -4z'
      />
    </g>
  </svg>
);

export default CloseIcon;
